module.exports = __webpack_public_path__ + "media/images/riders/small/ANNE_TERPSTRA-1b38da7020be0c6a22e43ffef3710086.png";